import { h, Component, createRef } from 'preact';
import postMessageManager from '../../../../services/postMessageManager';
import WrapperNewInviteComponent from './StyledComponent';

export default class WrapperNewInvite extends Component {
  constructor(props) {
    super(props);
    this.timeoutHeightCheck = this.timeoutHeightCheck.bind(this);
    this.pollElementHeight = this.pollElementHeight.bind(this);
    this.wrapperInviteRef = createRef();
    this.handleWindowResize = this.handleWindowResize.bind(this);
  }

  timeoutHeightCheck({ mobileInviteCurrentHeight, heightPollCounter }) {
    setTimeout(() => {
      this.pollElementHeight({ mobileInviteCurrentHeight, heightPollCounter });
    }, 200);
  }

  handleWindowResize(ev) {
    setTimeout(() => {
      let currentHeight = this.checkElementHeight();
      !!currentHeight && postMessageManager.sendMessage('inviteHeightChanged', {
        newHeight: currentHeight,
        formId: this.props.application.formId,
      });      
    }, 200);
  }

  checkElementHeight() {
    const elem = this.wrapperInviteRef?.current;
    const longerHeight = elem ? Math.max(elem.offsetHeight, elem.scrollHeight) : null;
    const currentHeight = longerHeight ? longerHeight + 18 : null;
    return currentHeight;
  }

  pollElementHeight({ mobileInviteCurrentHeight, heightPollCounter }) {
    const currentHeight = this.checkElementHeight();
    let heightPollCounterForTabLoop = 0;
    if (heightPollCounter < 30) {
      heightPollCounter += 1;
      this.timeoutHeightCheck({
        mobileInviteCurrentHeight: currentHeight,
        heightPollCounter,
      });
    }

    postMessageManager.sendMessage('inviteHeightChanged', {
      newHeight: currentHeight,
      formId: this.props.application.formId,
    });

    // Notify parent that the ref is available
    if (mobileInviteCurrentHeight > 30 &&
      this.props.onMobileInviteRendered &&
      heightPollCounterForTabLoop === 0) {
        heightPollCounterForTabLoop = heightPollCounter;
        this.props.onMobileInviteRendered();
    }
  }
  
  componentDidMount() {
    let mobileInviteCurrentHeight = 0;
    let heightPollCounter = 0;
    this.pollElementHeight({ mobileInviteCurrentHeight, heightPollCounter });
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  render() {
    return (
      <WrapperNewInviteComponent
        ref={this.wrapperInviteRef}
        backgroundColor={this.props.application.inviteData.mobileDesign.invitationBackgroundColor}
        className={'web-mobile-invitation'}
        position={this.props.application.position}
        isDirectionRtl={this.props.application.inviteData.isRtl}
      >
        {this.props.children}
      </WrapperNewInviteComponent>
    );
  }
}
